const isDev = window.location.hostname === "localhost";

export const API_URL = isDev
  ? "http://localhost:3001"
  : "https://lghrequests.com";

export const SOCKET_URL = isDev
  ? "http://localhost:3001"
  : "https://lghrequests.com";